import { Component, EventEmitter, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ExcursionItinerary } from 'src/app/shared/models/excursion-itineraries.interface';
import { ResponseMessage } from 'src/app/shared/models/response-message.interface';

@Component({
	selector: 'app-travel-board-response',
	templateUrl: './travel-board-response.component.html'
})
export class TravelBoardResponseComponent implements OnInit {

	public cancel: EventEmitter<any> = new EventEmitter<any>();

	public test: string;
	public responseMsg: ResponseMessage;
	public board: ExcursionItinerary;

	constructor(
		private modalRef: BsModalRef,
	) { }

	ngOnInit(): void {
		// console.log('TravelBoardResponseComponent.test:', this.test);
		// console.log('TravelBoardResponseComponent.responseMsg:', this.responseMsg);
		// console.log('TravelBoardResponseComponent.board:', this.board);
	}

	public closeModal() {
		this.cancel.emit();
		this.modalRef?.hide();
	}

}
